import type { SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { useNoodleSwr } from '@/hooks/useNoodleApi';
import type { CaseDataSchemaResponse } from '@/typings/api-models';

/** SWR hook for fetching the case data schema. */
export const useCaseDataSchema = (): SWRResponse<CaseDataSchemaResponse, ApiError> =>
  useNoodleSwr('/cases/schema', { revalidateOnFocus: false });
